import { UserOutlined } from '@ant-design/icons';
import { type IAttorneyDelegationData } from '@framework/frontoffice-submission/module/delegation/DelegationLogic.ts';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { DelegateUserNameWrapper } from './DelegateUserName.tsx';

interface IAttorneyUserNameProps {
  attorney: IAttorneyDelegationData | null | undefined;
}

/**
 * Componente dinamico per la visualizzazione del nome di un procuratore.
 */
export function AttorneyUserName(props: IAttorneyUserNameProps) {
  const { attorney } = props;
  const { t } = useTranslation();

  if (!attorney?.name && !attorney?.surname && !attorney?.fiscalCode)
    return (
      <Tag color="default">{t('delegate-username.nessuno', 'Nessuno')}</Tag>
    );

  const name =
    `${attorney.name ?? ''} ${attorney.surname ?? ''}`.trim() ??
    `${attorney.fiscalCode ?? ''}`;

  return (
    <DelegateUserNameWrapper>
      <UserOutlined aria-hidden />
      {name}
    </DelegateUserNameWrapper>
  );
}
